import { render, staticRenderFns } from "./GPUDownload.vue?vue&type=template&id=fc4ffc88&scoped=true&"
import script from "./GPUDownload.vue?vue&type=script&lang=js&"
export * from "./GPUDownload.vue?vue&type=script&lang=js&"
import style0 from "./GPUDownload.vue?vue&type=style&index=0&id=fc4ffc88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4ffc88",
  null
  
)

export default component.exports